export default __webpack_public_path__ + "images/EH.475c985.png";